<template>
  <div class="flex flex-col my-1">
    <label class="text-sm" :for="name" :class="{ 'error-input': error !== '' }">
      {{ label }}
    </label>
    <select
      :id="name"
      :class="customClass"
      :name="name"
      :value="value"
      :disabled="disabled"
      @change="
        ev => {
          $emit('input', ev.target.value);
        }
      "
    >
      <option
        v-for="option in optionsStandardized"
        :key="option.code"
        :value="option.code"
      >
        {{ option.name }}
      </option>
    </select>
    <p v-if="comment !== ''" class="text-blue-400">{{ comment }}</p>
    <span v-if="error !== ''" class="error-input">
      {{ error }}
    </span>
  </div>
</template>
<script>
export default {
  name: "SelectField",
  props: {
    value: {
      type: [String, Number],
      required: true
    },
    label: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      required: true
    },
    customClass: {
      type: String,
      default: "bordered"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default() {
        return [];
      }
    },
    required: {
      type: [Array, String],
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      error: ""
    };
  },
  computed: {
    comment() {
      return (
        this.options.find(option => option.code === this.value)?.comment || ""
      );
    },
    optionsStandardized() {
      return this.options.map(option => {
        if (typeof option === "string" || typeof option === "number") {
          return {
            name: option,
            code: option
          };
        } else {
          return {
            name: option.name,
            code: option.code
          };
        }
      });
    },
    name() {
      if (this.label && this.label != "") {
        return this.label.toLowerCase().replace(/\s|-/g, "_");
      }
      return "";
    }
  },
  watch: {
    value() {
      this.validate();
    }
  },
  methods: {
    validate() {
      let valid = true;
      if (this.value !== "") {
        this.rules.forEach((rule, index, arr) => {
          valid = rule(this.value);
          if (valid !== true) {
            this.error = valid;
            arr.length = index + 1;
            valid = false;
          }
        });
        if (valid === true) {
          this.error = "";
        }
      } else {
        if (Array.isArray(this.required) && this.required.length > 0) {
          valid = this.required[0](this.value);
          if (valid === true) {
            this.error = "";
            return true;
          } else {
            this.error = valid;
            valid = false;
          }
        } else {
          if (this.required === "") {
            if (this.value === "") {
              this.error = "This field is required";
              valid = false;
            } else {
              this.error = "";
            }
          }
        }
      }
      return valid;
    }
  }
};
</script>
<style lang="postcss" scoped>
select {
  padding: 10px 0px;
  border-bottom: 4px solid #d1d5db;
}
</style>
